import { Typography } from '@material-ui/core';
import { FormattedMessage } from 'react-intl';
import React from 'react';
import SectionChapter from '../../SectionChapter';
import TitleIcon from '@material-ui/icons/Title';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import PaletteIcon from '@material-ui/icons/Palette';
import TextFormatIcon from '@material-ui/icons/TextFormat';
import DragIndicatorIcon from '@material-ui/icons/DragIndicator';

const TextManagement = ({ language, classes, refs }) => {
    let explanations = [
        {
            id: 'tutorial.text.explanation1',
            children: (
                <ul>
                    <li>
                        <Typography>
                            <FormattedMessage
                                id='tutorial.text.toolIcon'
                                values={{
                                    b: (chunks) => <b>{chunks}</b>,
                                }}
                            />
                            <TitleIcon className={classes.sampleFab} />
                        </Typography>
                    </li>
                </ul>
            ),
        },
        {
            id: 'tutorial.text.creating',
            children: (
                <ul>
                    <li>
                        <Typography>
                            <FormattedMessage
                                id='tutorial.text.creating.explanation'
                                values={{
                                    b: (chunks) => <b>{chunks}</b>,
                                    li: (chunks) => (
                                        <span>
                                            {chunks}
                                            <br></br>
                                            <br></br>
                                        </span>
                                    ),
                                }}
                            />
                        </Typography>
                    </li>
                </ul>
            ),
        },
        {
            id: 'tutorial.text.editing',
            children: (
                <ul>
                    <li>
                        <Typography>
                            <FormattedMessage
                                id='tutorial.text.editing.explanation'
                                values={{
                                    b: (chunks) => <b>{chunks}</b>,
                                    li: (chunks) => (
                                        <span>
                                            {chunks}
                                            <br></br>
                                            <br></br>
                                        </span>
                                    ),
                                }}
                            />
                            <DragIndicatorIcon className={classes.sampleFab} />
                            <MoreVertIcon className={classes.sampleFab} />
                        </Typography>
                    </li>
                </ul>
            ),
        },
        {
            id: 'tutorial.text.formatting',
            children: (
                <ul>
                    <li>
                        <Typography>
                            <FormattedMessage
                                id='tutorial.text.formatting.explanation'
                                values={{
                                    b: (chunks) => <b>{chunks}</b>,
                                    li: (chunks) => (
                                        <span>
                                            {chunks}
                                            <br></br>
                                            <br></br>
                                        </span>
                                    ),
                                }}
                            />
                            <TextFormatIcon className={classes.sampleFab} />
                        </Typography>
                    </li>
                </ul>
            ),
        },
        {
            id: 'tutorial.text.styling',
            children: (
                <ul>
                    <li>
                        <Typography>
                            <FormattedMessage
                                id='tutorial.text.styling.color'
                                values={{ b: (chunks) => <b>{chunks}</b> }}
                            />
                            <PaletteIcon className={classes.sampleFab} />
                        </Typography>
                    </li>
                </ul>
            ),
        },
    ];
    return (
        <SectionChapter
            refs={refs}
            id={'section-manageLesson-text'}
            title={'tutorial.manageLesson.text.title'}
            explanations={explanations}
            imageTop={false}
        />
    );
};

export default TextManagement;
